import React, { useState } from "react";
import {
  Card,
  Table,
  Button,
  Dropdown,
  Form,
  Pagination,
} from "react-bootstrap";
import { FaPlus, FaRedo, FaSearch, FaTrashAlt, FaEdit } from "react-icons/fa";

const CouponsTable = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const [data, setData] = useState([
    {
      code: "NEWYEAR25",
      amount: "25%",
      canteen: "Central Canteen",
      validity: "2025-01-31",
      usage: "50",
      count: "45",
      usageLimit: "50",
      status: "Active",
    },
    {
      code: "FESTIVE10",
      amount: "10%",
      canteen: "North Wing Canteen",
      validity: "2025-01-15",
      usage: "20",
      count: "15",
      usageLimit: "20",
      status: "Inactive",
    },
  ]);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleDelete = (index) => {
    const newData = [...data];
    newData.splice(index, 1);
    setData(newData);
  };

  const filteredData = data.filter((item) =>
    item.code.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <Card
      className="p-3"
      style={{ width: "100%", display: "flex", flexDirection: "column" }}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Coupons List</h4>
        <div className="d-flex align-items-end">
          <Button variant="primary" className="d-flex align-items-center me-3">
            <FaPlus className="me-2" /> Add
          </Button>
          <div className="position-relative me-2" style={{ width: "300px" }}>
            <Form.Control
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
              style={{ borderRadius: "20px", paddingLeft: "35px" }}
            />
            <FaSearch
              style={{
                position: "absolute",
                left: "10px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
          </div>
          <Button variant="light" className="me-2">
            <FaRedo />
          </Button>
        </div>
      </div>
      <Card.Body style={{ flexGrow: 1, overflow: "auto" }}>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Code</th>
              <th>Amount</th>
              <th>Canteen</th>
              <th>Validity</th>
              <th>Usage</th>
              <th>Count</th>
              <th>Usage Limit</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((item, index) => (
              <tr key={index}>
                <td>{item.code}</td>
                <td>{item.amount}</td>
                <td>{item.canteen}</td>
                <td>{item.validity}</td>
                <td>{item.usage}</td>
                <td>{item.count}</td>
                <td>{item.usageLimit}</td>
                <td>
                  <span
                    className={`badge ${
                      item.status === "Active" ? "bg-success" : "bg-danger"
                    }`}
                  >
                    {item.status}
                  </span>
                </td>
                <td className="text-center">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="light"
                      size="sm"
                      className="border-0"
                    >
                      Actions
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      <Dropdown.Item>
                        <FaEdit className="me-2 text-primary" /> Edit
                      </Dropdown.Item>
                      <Dropdown.Item onClick={() => handleDelete(index)}>
                        <FaTrashAlt className="me-2 text-danger" /> Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            ))}
            {!paginatedData.length && (
              <tr>
                <td colSpan="9" className="text-center">
                  No results found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <div className="d-flex justify-content-between align-items-center mt-3">
          <span>
            Showing {startIndex + 1}-
            {Math.min(startIndex + itemsPerPage, filteredData.length)} of{" "}
            {filteredData.length} entries
          </span>
          <Pagination>
            <Pagination.Prev
              onClick={() => handlePageChange(currentPage - 1)}
            />
            {[...Array(totalPages)].map((_, i) => (
              <Pagination.Item
                key={i}
                active={i + 1 === currentPage}
                onClick={() => handlePageChange(i + 1)}
              >
                {i + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next
              onClick={() => handlePageChange(currentPage + 1)}
            />
          </Pagination>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CouponsTable;
